import Wrapper from "components/blocks/Wrapper";
import Container from "components/blocks/Container";
import {wrapper} from "lib/store";
import {getPaginatedLocationsThunk} from "lib/features/mapSlice";
import {useDispatch, useSelector} from "react-redux";
import {useRouter} from "next/router";
import {solid} from '@fortawesome/fontawesome-svg-core/import.macro'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import _ from 'lodash'
import LocationCard from "components/cards/LocationCard";
import MapCard from 'components/cards/MapCard'
import {Box, Button, Checkbox, FormControlLabel, MenuItem, Popover, Select} from "@mui/material";
import React, {useCallback, useEffect, useState} from "react";
import {GoogleMap, InfoWindow, Marker, useJsApiLoader} from '@react-google-maps/api';
import Link from "next/link";
import mapStyles from 'lib/mapStyles'
import DefaultLayout from "layouts/Default";
import ImageWithFallback from "components/ImageWithFallback";
import {checkMobile, checkSubset, locate, sortByItem} from '../../utils/helper'
import MapDetailCard from "components/cards/MapDetailCard";
import config from '../../data/config.json'
import Grid from "@mui/material/Grid";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {useTranslation} from "next-i18next";
import ListWithPagination from 'components/ListWithPagination'
import IconButton from "@mui/material/IconButton";
import Drawer from "@mui/material/Drawer";

const GEO_MARKER_ICON = 'data:image/svg+xml;base64,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';
const MARKER = 'data:image/svg+xml;base64,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';


const filter_key_map = {
  amenities: 'amenities',
  locationTypes: 'location_type'
}

export const getServerSideProps = wrapper.getServerSideProps(store => async (context) => {
  const {
    query,locale,
  } = context
  const {
    page = 1,
    latitude = '',
    longitude = '',
    locationTypes = [],
    amenities = [],
    openNow = false,
    sort = {},
  } = query
  const filter = {
    latitude: parseFloat(latitude),
    longitude: parseFloat(longitude),
    locationTypes,
    amenities,
    openNow
  }
  await store.dispatch(getPaginatedLocationsThunk({page, filter, sort}))

  return {
    props: {
      page,
      filter,
      sort,
      ...(await serverSideTranslations(locale, ['home', 'common']))
    }
  }
})


export default function Stores(props) {
  const {
    page: _page,
    filter: _filter,
    sort: _sort,
  } = props

  const { t, i18n } = useTranslation()


  const SORT_OPTIONS = config.map.sort
  let LOCATION_TYPES = config.location.type.map(item => ({
    label: item.key,
    slug: _.kebabCase(item.label),
    value: item.value
  }))
  let AMENITIES = config.location.amenities.slice(0, 14).map((item, index) => ({
    label: t(`home:${item.key}`),
    slug: _.kebabCase(item.name),
    count: (index + 1).toString()
  }))

  const router = useRouter()
  const dispatch = useDispatch()
  let locations = useSelector(state => state.map.locations)
  const [listingMode, setListingMode] = useState(router.query.listingMode || 'list')
  const [filter, setFilter] = useState(_filter)
  const [sort, setSort] = useState(SORT_OPTIONS.find(s => s.sort.sortBy === _sort.sortBy && s.sort.order === _sort.order) || SORT_OPTIONS[0])

  const [filteredLocations, setFilteredLocations] = useState(locations)
  const [sortedLocations, setSortedLocations] = useState([])
  const [activeMarker, setActiveMarker] = useState(null)

  const [selectedStore, setSelectedStore] = useState(null)
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showAmenitiesPop, setShowAmenitiesPop] = useState(false)
  const [loaded, setLoaded] = useState(false)
  const [test, setTest] = useState(0)
  const openAmenities = (event) => {
    setAnchorEl(event.currentTarget);
    setShowAmenitiesPop(true)
  }
  const closeAmenities = () => {
    setAnchorEl(null);
    setShowAmenitiesPop(false)
  }
  const open = Boolean(anchorEl);
  const id = open ? 'amenitiesPop' : undefined;

  const filterStore = (localList, filter) => {
    let temp = localList
    console.log('filtering: ', filter)
    if (JSON.stringify(filter) !== '{}') {
      for (let key in filter) {
        if (filter.hasOwnProperty(key)) {
          if (filter[key].length > 0) {
            if (key === 'amenities') {
              let list = temp.filter(item => checkSubset(item[filter_key_map[key]], filter[key]))
              console.log('amenities filtered: ', list.length)
              temp = list
            }
            if (key === 'locationTypes') {
              let tempList = []
              for (let i = 0; i < filter[key].length; i ++) {
                let list = temp.filter(item => item[filter_key_map[key]] === filter[key][i])
                tempList = tempList.concat(list)
              }
              console.log('location type filtered: ', temp.length)
              temp = tempList
            }
          }
        }
      }
    }
    console.log('this is filtered: ', temp.length)
    return temp
  }

  const sortStore = (localList, sortBy) => {
    let temp = localList
    if (locations && localList.length > 0) {
      return sortByItem(temp, sortBy.sort.sortBy, sortBy.sort.order)
    } else {
      return temp
    }
  }

  const renderSortedLocations = (list) => {
    return (
        !!list && list.length > 0 ? list.map(location => (
            <LocationCard
                showDetails={true}
                onMouseEnter={() => panToLocation(location)}
                key={location.slug+ location.id}
                data={location} row
                className={'p-3 border-b cursor-pointer'}
                setSelectedStore={setSelectedStore}
                t={t}
            />
        )) : null
    )
  }

  const updateSorted =  (list) => {
    setTest(prevState => prevState + 1)
    setSortedLocations(list)
  }

  useEffect(() => {
    if (loaded) {
      let temp = filterStore(locations, filter)
      setFilteredLocations(temp)
    }
  }, [loaded, filter])

  useEffect(() => {
    if (loaded) {
      let res = sortStore(filteredLocations, sort)
      updateSorted(res)
    }
  }, [loaded, sort, filteredLocations])

  useEffect(() => {
    console.log('init filtered locations: ', locations.length, AMENITIES)
    setLoaded(true)
  }, [])

  const handleSortChange = (event) => {
    setSort(event.target.value)
  }
  const handleFilterChange = (field, value) => {
    console.log('field', value)
    if (field === 'locationTypes') {
      setFilter({
        ...filter,
        locationTypes: _.xor(filter.locationTypes, [value])
      })
    } else if (field === 'amenities') {
      setFilter({
        ...filter,
        amenities: _.xor(filter.amenities, [value])
      })
    } else if (field === 'openNow') {
      setFilter({
        ...filter,
        openNow: !filter.openNow
      })
      console.log(filter)
    }
  }

  const {isLoaded} = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: "AIzaSyAjKpb5fMYUxjqYLuCj5No8vhC9gXR3nKk"
  })

  const [map, setMap] = useState(null)
  const [geo, setGeo] = useState({
    located: false,
    latitude: filter.latitude,
    longitude: filter.longitude,
  })
  const [bounds, setBounds] = useState({
    changed: false,
  })
  const [center, setCenter] = useState({lat: filter.latitude, lng: filter.longitude});

  useEffect(() => {
    console.log('geo: ', geo)
  }, [geo])

  useEffect(() => {
    if (geo.located) {
      panToCurrentLocation()
    }
  }, [geo.located])

  const onMapLoad = useCallback(map => {
    setMap(map)
    locate(setGeo)
  }, [])

  const onMapUnmount = useCallback(map => {
    setMap(null)
  }, [])

  const onBoundsChanged = useCallback(_.debounce(() => {
    if (!map) return
    const newBounds = map.getBounds()
    const northEast = newBounds.getNorthEast();
    const southWest = newBounds.getSouthWest();
    setBounds({
      changed: true,
      minLat: Math.min(northEast.lat(), southWest.lat()),
      minLng: Math.min(northEast.lng(), southWest.lng()),
      maxLat: Math.max(northEast.lat(), southWest.lat()),
      maxLng: Math.max(northEast.lng(), southWest.lng()),
    })
    setCenter(map.getCenter())
  }, 500), [map])

  const redoSearch = () => {
    dispatch(getPaginatedLocationsThunk({
      page: 1,
      filter: {
        ...filter,
        bounds: _.omit(bounds, 'changed')
      },
      sort: sort.sort
    }))
    setBounds({
      ...bounds,
      changed: false,
    })
  }



  const panToCurrentLocation = () => {
    if (map) {
      map.setZoom(13)
      map.panTo({
        lat: geo.latitude,
        lng: geo.longitude
      })
    }
  }

  const panToLocation = useCallback(_.debounce((location) => {
    console.log(location.slug)
    map.panTo({
      lat: location.latitude,
      lng: location.longitude,
    })
  }, 300), [map])

  const [isMobile, setIsMobile] = useState(false)
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileBTOpen, setMobileBTOpen] = useState(false);

  useEffect(() => {
    if (loaded) {
      setIsMobile(checkMobile())
    }
  }, [loaded])

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const handleBusinessTypeDrawerOpen = () => {
    setMobileBTOpen((prevState) => !prevState);
  };

  const drawerWidth = 240;

  useEffect(() => {
    if (loaded) {
      setIsMobile(checkMobile())
    }
  }, [loaded])

  const drawer = (
      <Box className={"p-5"} sx={{ textAlign: 'center' }}>
        <Link href={'/map'} passHref shallow>
          <div onClick={() => setListingMode('map')}
               className="flex mb-4 border hover:border-gray-300 rounded h-20 items-center cursor-pointer overflow-hidden">
            <div className="w-1/2 text-center text-sm font-semibold">
              {t('home:map_viewAsMap')}
            </div>
            <div className="w-1/2 h-full relative">
              <ImageWithFallback layout={'fill'} className={'object-cover'} src={require('assets/pseudo-map.png')} alt={'map'}/>
            </div>
          </div>
        </Link>
        <div className="pb-2 border-b mb-4">
          <FontAwesomeIcon icon={solid('sliders')}/>
          <span className={'ml-2 font-semibold'}>{t('home:filter')}</span>
        </div>
        <div className="mb-4">
          <div className="font-semibold text-sm mb-2">{t('home:businessType')}</div>
          {
            LOCATION_TYPES.map(item => (
                <FormControlLabel
                    key={item.slug}
                    label={<span className={'text-sm'}>{t(`home:${item.label}`)}</span>}
                    className={'flex items-center -mb-1'}
                    control={
                      <Checkbox
                          checked={filter.locationTypes.includes(item.value)}
                          onChange={e => handleFilterChange('locationTypes', item.value)}
                          size={'small'} className={'text-primary-dark'}
                      />
                    }
                />
            ))
          }
        </div>
        <div className="mb-4">
          <div className="font-semibold text-sm mb-2">{t('home:amenities')}</div>
          {
            AMENITIES.map(t => (
                <FormControlLabel
                    key={t.slug}
                    label={<span className={'text-sm'}>{t.label}</span>}
                    className={'flex items-center -mb-1'}
                    control={
                      <Checkbox
                          checked={filter.amenities.includes(t.count)}
                          onChange={e => handleFilterChange('amenities', t.count)}
                          size={'small'} className={'text-primary-dark'}
                      />
                    }
                />
            ))
          }
        </div>
      </Box>
  )

  const renderMobileFilter = () => {
    return (
        <>
          <div className="w-auto">
            <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ display: { sm: 'none' } }}
                className="flex flex-row justify-start"
            >
              <FontAwesomeIcon icon={solid('sliders')}/>
              <span className={'ml-2 font-semibold min-w-[32px]'}>{t('home:filter')}</span>
            </IconButton>
          </div>
          <Box component="nav">
            <Drawer
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{
                  keepMounted: true, // Better open performance on mobile.
                }}
                sx={{
                  display: { xs: 'block', sm: 'none' },
                  '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                }}
            >
              {drawer}
            </Drawer>
          </Box>
        </>
    )
  }

  const businessTypeDrawer = (
      <div className="p-5">
        <Link href={'/map'} passHref shallow>
          <div onClick={() => setListingMode('list')}
               className="mb-5 flex border hover:border-gray-300 rounded h-20 items-center cursor-pointer overflow-hidden">
            <div className="w-full text-center text-sm font-semibold">
              {t('home:map_viewaslist')}
            </div>
          </div>
        </Link>
        <div className="inline-block font-semibold text-sm mr-4">{t('home:businessType')}</div>
        {
          LOCATION_TYPES.map((item) => (
              <FormControlLabel
                  key={item.slug}
                  label={<span className={'text-sm'}>{t(`home:${item.label}`)}</span>}
                  className={'inline-flex items-center'}
                  control={
                    <Checkbox
                        checked={filter.locationTypes.includes(item.value)}
                        onChange={e => handleFilterChange('locationTypes', item.value)}
                        size={'small'} className={'text-primary-dark'}
                    />
                  }
              />
          ))
        }
      </div>
  )


  const renderMobileBusinessType = () => {
    return (
        <>
          <div className="w-auto flex flex-row justify-between">
            <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleBusinessTypeDrawerOpen}
                sx={{ display: { sm: 'none' } }}
                className={'border-solid rounded border border-[#DDDDDD] mr-6'}
            >
              <FontAwesomeIcon className={showAmenitiesPop ? 'text-white' : 'text-black'} icon={solid('list-radio')} />
              <span className={'text-black ml-2 text-base'}>{t('home:businessType')}</span>
            </IconButton>
            <IconButton aria-describedby={id} onClick={openAmenities}  className={showAmenitiesPop ? 'rounded bg-[#108085]' : 'border-solid rounded border border-[#DDDDDD]'}>
              <FontAwesomeIcon className={showAmenitiesPop ? 'text-white' : 'text-black'} icon={solid('sliders')} />
              <span className={showAmenitiesPop ? 'text-white ml-2 text-base' : 'text-black ml-2 text-base'}>{t('home:filter')}</span>
            </IconButton>
          </div>
          <Box component="nav">
            <Drawer
                variant="temporary"
                open={mobileBTOpen}
                onClose={handleBusinessTypeDrawerOpen}
                ModalProps={{
                  keepMounted: true, // Better open performance on mobile.
                }}
                sx={{
                  display: { xs: 'block', sm: 'none' },
                  '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                }}
            >
              {businessTypeDrawer}
            </Drawer>
          </Box>
        </>
    )
  }

  return (
    listingMode === 'map'
      ? <Wrapper className={'pb-0'}>
        <Container>
          <div className={"flex gap-8 mb-8"}>
            {
              isMobile ?
                  null :
                  <Link href={'/map'} passHref shallow>
                    <div onClick={() => setListingMode('list')}
                         className="w-4/12 flex border hover:border-gray-300 rounded h-20 items-center cursor-pointer overflow-hidden">
                      <div className="w-full text-center text-sm font-semibold">
                        {t('home:map_viewaslist')}
                      </div>
                    </div>
                  </Link>
            }
            <div className="w-8/12">
              <div className="flex flex-row w-full items-between mb-2 justify-between">
                <h2 className={"text-2xl font-bold"}>{t('home:map_browsestores')}</h2>
                <div className="">
                  {
                    isMobile ? null :
                        <Button aria-describedby={id} onClick={openAmenities}  className={showAmenitiesPop ? 'rounded bg-[#108085]' : 'border-solid rounded border border-[#DDDDDD]'}>
                          <FontAwesomeIcon className={showAmenitiesPop ? 'text-white' : 'text-black'} icon={solid('list-radio')} />
                          <span className={showAmenitiesPop ? 'text-white ml-2' : 'text-black ml-2'}>{t('home:filter')}</span>
                        </Button>
                  }
                    <Popover
                        id={id}
                        className={'w-full'}
                        open={showAmenitiesPop}
                        onClose={closeAmenities}
                        anchorEl={anchorEl}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right"
                        }}
                        PaperProps={{
                          style: {
                            backgroundColor: "transparent",
                            boxShadow: "none",
                            borderRadius: 0
                          }
                        }}
                    >
                      <Box
                          className={isMobile ? 'p-8 bg-[#f0f0ef] w-full float-right' : 'p-8 bg-[#f0f0ef] w-6/12 float-right'}
                          sx={{
                            boxShadow: 1,
                            position: "relative",
                            mt: "30px",
                            "&::before": {
                              backgroundColor: "#f0f0ef",
                              content: '""',
                              display: "block",
                              position: "absolute",
                              width: 12,
                              height: 12,
                              top: -6,
                              transform: "rotate(45deg)",
                              left: "calc(83% - 6px)"
                            }
                          }}
                      >
                          <h2 className={"text-2xl font-bold"}>{t('home:amenities')}</h2>
                          <Grid container>
                            {
                              AMENITIES.map((t) => (
                                  <Grid
                                      key={t.slug + t.label}
                                      item xs={6} lg={3} xl={2}
                                  >
                                    <FormControlLabel
                                        label={<span className={'text-sm'}>{t.label}</span>}
                                        // className={'inline-flex items-center'}
                                        control={
                                          <Checkbox
                                              checked={filter.amenities.includes(t.count)}
                                              onChange={e => handleFilterChange('amenities', t.count)}
                                              size={'small'} className={'text-primary-dark'}
                                          />
                                        }
                                    />
                                  </Grid>
                              ))
                            }
                          </Grid>
                      </Box>
                    </Popover>
                </div>
              </div>
              {
                isMobile ?
                    renderMobileBusinessType() :
                    <div className="">
                      <div className="inline-block font-semibold text-sm mr-4">{t('home:businessType')}</div>
                      {
                        LOCATION_TYPES.map((item) => (
                            <FormControlLabel
                                key={item.slug}
                                label={<span className={'text-sm'}>{t(`home:${item.label}`)}</span>}
                                className={'inline-flex items-center'}
                                control={
                                  <Checkbox
                                      checked={filter.locationTypes.includes(item.value)}
                                      onChange={e => handleFilterChange('locationTypes', item.value)}
                                      size={'small'} className={'text-primary-dark'}
                                  />
                                }
                            />
                        ))
                      }
                    </div>
              }
            </div>
          </div>
        </Container>
        <div className={"h-[140vh]"}>
          <div className={isMobile ? 'relative h-[65%] sticky top-[27px] flex items-start' : "relative h-[calc(100vh-87px)] sticky top-[87px] flex items-center"}>
            <Container className={isMobile ? 'h-[65%] w-full flex  pointer-events-none relative' : 'h-4/5 max-w-full w-full flex p-8 pointer-events-none relative z-10'}>
              <div className="w-96 flex flex-col bg-white border rounded overflow-hidden pointer-events-auto shadow">
                <div className="shrink-0 flex justify-between items-center p-3 bg-gray-100 shadow-md z-10">
                  {
                    !!selectedStore ?
                        <div onClick={() => {
                          setSelectedStore(null)
                        }}  className={'flex flex-row items-center cursor-pointer'}>
                          <FontAwesomeIcon icon={solid('chevron-left')}/>
                          <span className={"ml-3 text-sm"}>{t('home:map_backToResults')}</span>
                        </div> :
                        <>
                          <span className={'text-sm'}>{`${t('home:map_showing_results1')} ${filteredLocations.length} ${t('home:map_showing_results2')}`}</span>
                          <Select
                              value={sort}
                              onChange={handleSortChange}
                              size={'small'} className={"w-52 text-sm bg-white"}
                          >
                            {
                              SORT_OPTIONS.map(option => (
                                  <MenuItem key={option.label} value={option}>{option.label}</MenuItem>
                              ))
                            }
                          </Select>
                        </>
                  }
                </div>
                <div className={'min-h-0 overflow-auto'}>
                  {
                    !!selectedStore ?
                        <MapDetailCard isMobile={isMobile} i18n={i18n} t={t} key={selectedStore.slug} data={selectedStore} row className={'mb-1 p-2 rounded-md'} />
                          :
                        <>
                          <h3 className={"font-bold p-3 border-b text-sm"}>{t('home:all_result')}</h3>
                          {
                            loaded ?
                                renderSortedLocations(sortedLocations) :
                                <Container style={{ marginTop: 50 }}>
                                  <span>{t('home:loading')}</span>
                                </Container>

                          }
                        </>
                  }
                </div>
              </div>
              {
                isMobile ?
                    null :
                    <div className="flex grow self-start justify-center">
                      {
                        bounds.changed &&
                        <Button variant={'contained'}
                                onClick={redoSearch}
                                className={'rounded-full pointer-events-auto'}
                        >
                          {t('home:map_search_this_area')}
                        </Button>
                      }
                    </div>
              }
            </Container>
            {
              isLoaded &&
              <GoogleMap
                  onClick={() => {
                    setActiveMarker(null)
                  }}
                mapContainerStyle={isMobile ? {position: 'absolute', top: '70%', right: 0, bottom: 0, left: 0,} : {
                  position: 'absolute',
                  top: 0, right: 0, bottom: 0, left: 0,

                }}
                center={center}
                zoom={10}
                onLoad={onMapLoad}
                onUnmount={onMapUnmount}
                onDragEnd={onBoundsChanged}
                onZoomChanged={onBoundsChanged}
                options={{
                  styles: mapStyles
                }}
              >
                {
                  geo.located &&
                  <Marker
                    icon={GEO_MARKER_ICON}
                    position={{
                      lat: geo.latitude,
                      lng: geo.longitude
                    }}
                  />
                }
                {
                  filteredLocations.map(loc => {
                    if (loc.latitude && loc.longitude) {
                      return (
                          <Marker
                              onMouseOver={() => {
                                setActiveMarker(loc.id)
                              }}
                              key={loc.id}
                              icon={MARKER}
                              position={{
                                lat: loc.latitude,
                                lng: loc.longitude
                              }}
                          >
                            {
                              activeMarker === loc.id ?
                                  (
                                      <InfoWindow
                                          // onLoad={onLoad}
                                          position={{
                                            lat: loc.latitude,
                                            lng: loc.longitude
                                          }}
                                          className={'h-100 w-full'}
                                      >
                                        <MapCard t={t} key={loc.slug} data={loc} row className={'mb-1 p-2 rounded-md'}/>
                                      </InfoWindow>
                                  ) : null
                            }
                          </Marker>
                      )
                    }
                  })
                }
              </GoogleMap>
            }
          </div>
        </div>
      </Wrapper>
      : <Wrapper>
        <Container>
          <div className={isMobile ? 'flex flex-col' : 'flex gap-8'}>
            {
              isMobile ?
                    null :
                  <div className={"w-4/12"}>
                    <Link href={'/map'} passHref shallow>
                      <div onClick={() => setListingMode('map')}
                           className="flex mb-4 border hover:border-gray-300 rounded h-20 items-center cursor-pointer overflow-hidden">
                        <div className="w-1/2 text-center text-sm font-semibold">
                          {t('home:map_viewAsMap')}
                        </div>
                        <div className="w-1/2 h-full relative">
                          <ImageWithFallback layout={'fill'} className={'object-cover'} src={require('assets/pseudo-map.png')} alt={'map'}/>
                        </div>
                      </div>
                    </Link>
                    <div className="pb-2 border-b mb-4">
                      <FontAwesomeIcon icon={solid('sliders')}/>
                      <span className={'ml-2 font-semibold'}>{t('home:filter')}</span>
                    </div>
                    <div className="mb-4">
                      <div className="font-semibold text-sm mb-2">{t('home:businessType')}</div>
                      {
                        LOCATION_TYPES.map(item => (
                            <FormControlLabel
                                key={item.slug}
                                label={<span className={'text-sm'}>{t(`home:${item.label}`)}</span>}
                                className={'flex items-center -mb-1'}
                                control={
                                  <Checkbox
                                      checked={filter.locationTypes.includes(item.value)}
                                      onChange={e => handleFilterChange('locationTypes', item.value)}
                                      size={'small'} className={'text-primary-dark'}
                                  />
                                }
                            />
                        ))
                      }
                    </div>
                    <div className="mb-4">
                      <div className="font-semibold text-sm mb-2">{t('home:amenities')}</div>
                      {
                        AMENITIES.map(t => (
                            <FormControlLabel
                                key={t.slug}
                                label={<span className={'text-sm'}>{t.label}</span>}
                                className={'flex items-center -mb-1'}
                                control={
                                  <Checkbox
                                      checked={filter.amenities.includes(t.count)}
                                      onChange={e => handleFilterChange('amenities', t.count)}
                                      size={'small'} className={'text-primary-dark'}
                                  />
                                }
                            />
                        ))
                      }
                    </div>
                  </div>
            }
              <div className={isMobile ? "w-full" : "w-8/12"}>
                {
                  isMobile ?
                      null :
                      <div className="flex items-center pb-2 border-b mb-4">
                        <FontAwesomeIcon icon={solid('sliders')}/>
                        <span className={'ml-2 font-semibold min-w-[32px]'}>{t('home:filter')}</span>
                      </div>
                }
              <h2 className={"text-2xl font-bold mb-4"}>{t('home:map_browsestores')}</h2>
                {
                  isMobile ?
                      renderMobileFilter() : null
                }
              <div className="flex mb-6 items-center justify-between">
                {
                  `${t('home:map_showing_results1')} ${filteredLocations.length} ${t('home:map_showing_results2')}`
                }
                <Select
                  value={sort}
                  onChange={handleSortChange}
                  size={'small'} className={"w-52 text-sm"}
                >
                  {
                    SORT_OPTIONS.map(option => (
                      <MenuItem key={option.label} value={option}>{option.label}</MenuItem>
                    ))
                  }
                </Select>
              </div>
              <div>
                {/*<h3 className={"font-bold mb-4"}>{t('home:all_result')}</h3>*/}
                {/*{*/}
                {/*  filteredLocations.map(location => (*/}
                {/*    <LocationCard t={t} key={location.slug + location.id} data={location} row className={'mb-4 p-3 rounded-md border'}/>*/}
                {/*      */}
                {/*  ))*/}
                {/*}*/}
                <ListWithPagination
                    pageSize={10}
                    dataList={filteredLocations}
                    itemComponent={LocationCard}
                    onMouseEnter={() => panToLocation(location)}
                    setSelectedStore={setSelectedStore}
                    t={t}
                />
              </div>
            </div>
          </div>
        </Container>
      </Wrapper>
  )
}

Stores.getLayout = function getLayout(page) {
  return (
      <DefaultLayout>
        {page}
      </DefaultLayout>
  )
}
